import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const createKbArticle = createAsyncThunk(
    'kbArticle/createKbArticle',
    async (articleData, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;

            const response = await axios.post(
                `${ROOT_URL}/kb/article/create`, // Endpoint as per request
                articleData,
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.error("Error creating article:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const createKbArticleSlice = createSlice({
    name: 'createKbArticle',
    initialState,
    reducers: {
        resetCreateKbArticleState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createKbArticle.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(createKbArticle.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(createKbArticle.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    }
});

export const { resetCreateKbArticleState } = createKbArticleSlice.actions;
export default createKbArticleSlice.reducer;
